import { render } from "./projects-table.vue?vue&type=template&id=8ce7acd2"
import script from "./projects-table.vue?vue&type=script&lang=js"
export * from "./projects-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__